import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import { MaterialReactTable } from "material-react-table";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import BreadCrumb from "../Common/BreadCrumb";
import { Loader } from "../Utils/Loader";
import CommonModal from "../Utils/CommonModal";
import { PolicyRowOptions } from "./PolicyRowOptions";
import { PolicyCustomButtons } from "./PolicyCustomButton";
import { PoliciesColoumn } from "./constants/PolicyColoumn";
import { getAllPolicies } from "../../slices/Policy/thunk";
import { deletePolicies } from "../../slices/Policy/DeletePolicy/thunk";
import { setEditSuccessMessage, setSuccessMessage } from "../../slices/toastMessage/action";
import { getView } from "../../slices/View/thunk";
import { useColumnSettings } from "../Utils/useColumnSettings";
import { MenuItem } from "@mui/material";
import { handleExportData } from "../Utils/ExportToCsv";
import { navigateToAddPolicy } from "./constants/jsonconstant";
import { hasPermission } from "../Utils/UtilityFunctions";

export default function PolicyListing() {
    const [loading, setLoading] = useState()
    const [messageForPopUp, setMessageForPopUp] = useState('')
    const [modal, setModal] = useState(false);
    const [policyName, setPolicyName] = useState()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const columns = PoliciesColoumn()
    const toggleModal = (id) => {
        setPolicyName(id)
        setModal(!modal);
        document.body.style.overflow = 'auto'
    };
    useEffect(() => {
        dispatch(getAllPolicies(setLoading));
        dispatch(getView(setLoading))
    }, [dispatch]);
    const Policies = useSelector((state) => state?.GetAllPolicies?.getAllPolicies);
    const showSuccessMessage = useSelector((state) => state.SuccessToast.showSuccessMessage)
    const showEditSuccessMessage = useSelector((state) => state.SuccessToast.showEditSuccessMessage);
    const rawPermissions = useSelector(
        (state) => state.permissions.permissionsMap
    );

    const permissionsMap = new Map(
        rawPermissions.map(([key, value]) => [key, new Set(value)])
    );
    const policyPermission = hasPermission(permissionsMap, "charging", "policy")
    const viewPermission = hasPermission(permissionsMap, "miscellaneous", "view")

    const {
        CustomViewModal,
        settingsModalOpen,
        viewColumns,
        toggleSettingsModal,
        SettingsSidebar
    } = useColumnSettings('policy', columns);
    useEffect(() => {
        if (showSuccessMessage) {
            toast.success(`Policy Created Successfully`);
            dispatch(setSuccessMessage(false))
        }
        if (showEditSuccessMessage) {
            toast.success(`Policy Updated Successfully`);
            dispatch(setEditSuccessMessage(false));
        }
    }, [showSuccessMessage, showEditSuccessMessage, dispatch])
    return (
        <React.Fragment>
            <div id='csms' className='page-content bg-white mb-0'>
                <Container fluid>
                    <BreadCrumb title="Policy Specs" pageTitle="Charging" />
                    <ToastContainer position='top-center' />
                    <div className="d-flex flex-sm-row flex-column w-100 justify-content-between align-items-lg-center gap-2 mb-1 mt-0">
                        <div className="d-flex flex-row gap-2">
                            <h5 className="rv-page-title p-2">Policy Specs List</h5>
                        </div>
                        <div className="d-flex align-items-center">
                            {policyPermission && policyPermission?.has("export") &&
                                <Button
                                    color="secondary"
                                    className="btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 me-2 w-md-auto text-nowrap"
                                    onClick={() => { handleExportData(Policies) }}
                                >
                                    <i className="ri-download-line label-icon secondary-label-icon align-middle fs-16 me-2"></i>
                                    <span className="px-2 ps-3 ms-2 me-1">Export</span>
                                </Button>}
                            {policyPermission && policyPermission?.has("create") &&
                                <Button
                                    color="secondary"
                                    className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 me-2 w-md-auto text-nowrap"
                                    onClick={() => navigateToAddPolicy(navigate)}
                                >
                                    <i className="ri-add-fill label-icon align-middle fs-16 me-1"></i>
                                    <span className="ps-2 ms-2 me-1">Add Policy</span>
                                </Button>}
                            {viewPermission && viewPermission?.has("view") &&
                                <i className="ri-settings-2-line fs-4" onClick={toggleSettingsModal}></i>}
                        </div>
                        {CustomViewModal()}
                    </div>
                    <Row className="d-flex align-items-sm-start">
                        <Col lg={12}>
                            <div className="container-fluid px-0">
                                <div className="disable-margin-card table-responsive table-customer border w-100">
                                    {loading && (<Loader />)}
                                    {Policies ?
                                        <MaterialReactTable
                                            enableTopToolbar={false}
                                            icons={{ DragHandleIcon: () => <i className="ri-drag-move-fill" />, }}
                                            positionToolbarAlertBanner='none'
                                            enableSorting={true}
                                            enableColumnDragging={false}
                                            enableRowActions={true}
                                            enableDensityToggle={false}
                                            enableColumnFilters={true}
                                            enableColumnActions={true}
                                            displayColumnDefOptions={{
                                                'mrt-row-actions': {
                                                    header: '',
                                                    enableHiding: true,
                                                    size: 36,
                                                    grow: true,
                                                    muiTableBodyCellProps: {
                                                        sx: {
                                                            fontFamily: "Inter,sans-serif",
                                                            maxWidth: "60px"
                                                        }
                                                    },
                                                    muiTableHeadCellProps: {
                                                        sx: {
                                                            fontFamily: "Inter,sans-serif",
                                                            maxWidth: "60px"
                                                        }
                                                    }
                                                },
                                            }}
                                            layoutMode='grid'
                                            defaultColumn={{
                                                // minSize: 10,
                                                maxSize: 9001,
                                                size: 260,
                                                muiTableBodyCellProps: {
                                                    sx: {
                                                        fontFamily: "Inter,sans-serif"
                                                    }
                                                },
                                                muiTableHeadCellProps: {
                                                    sx: {
                                                        fontFamily: "Inter,sans-serif"
                                                    }
                                                }
                                            }}
                                            columns={columns.filter((column) => viewColumns?.includes(column.accessorKey || column.header))}
                                            data={Policies}
                                            enableColumnOrdering
                                            renderRowActionMenuItems={({ closeMenu, row }) => [
                                                policyPermission && policyPermission?.has("update") ?
                                                    <MenuItem className='row-options pb-3' data-testid="update" key="update" onClick={() => { navigate(`/edit-policies/${row.original.policyLabel}`) }} >
                                                        <i className='ri-edit-box-line me-2' /> Edit </MenuItem> : null,
                                                policyPermission && policyPermission?.has("delete") ?
                                                    <MenuItem className='row-options pb-3' key="delete" onClick={() => { setMessageForPopUp(`Are you sure you want to Delete this Policy "${row.original.policyLabel}"?`), toggleModal(row), closeMenu() }}>
                                                        <i className="ri ri-delete-bin-5-line me-2" />{" "}
                                                        Delete
                                                    </MenuItem> : null,
                                            ]}
                                        /> : null}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container >
            </div >
            <div>
                <CommonModal open={modal} modalHeader={'Delete Policy'} toggle={toggleModal} buttonText={"Yes, Delete It"} messageForPopUp={messageForPopUp} modalAction={() => {
                    dispatch(deletePolicies(policyName.original?.policyLabel, setLoading))
                    toggleModal()
                }} />
            </div>
        </React.Fragment >
    )
}